<ion-header class="ion-no-border" mode='ios'>
  <ion-toolbar>
    <ion-icon id="backIcon" color="secondary" name="chevron-back-outline" routerDirection="root" [routerLink]="['/dashboard']"></ion-icon>
    <ion-title>{{this.translate.instant('272')}}</ion-title>
    <ion-button mode='ios' slot="end" (click)="this.modalCtrl.dismiss()" fill="clear">
      <ion-icon slot="icon-only" name="close-circle-outline" color="primary"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-item>
    <ion-label>{{this.translate.instant('273')}}</ion-label>
    <ion-input labelPlacement="stacked" type="text" [(ngModel)]="cod_set"></ion-input>
  </ion-item>
  <ion-item>
    <ion-label>{{this.translate.instant('090')}}</ion-label>
    <ion-input labelPlacement="stacked" type="text" [(ngModel)]="des_set"></ion-input>
  </ion-item>

</ion-content>

<ion-footer class="ion-no-border" *ngIf="this.cod_set !== '' && this.des_set !== ''">
  <ion-toolbar class="ion-text-center">
    <ion-button (click)="creaSet()" mode="ios">{{this.translate.instant('160')}}</ion-button>
  </ion-toolbar>
</ion-footer>
